<script setup>
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import { ref, watch } from "vue";

const emits = defineEmits(["update:content"]);

const props = defineProps({
  content: {
    type: String,
    default: "",
  },
});

const editor = ref(null);

const textChange = () => {
  emits("update:content", editor.value?.getHTML());
};

watch(
  () => props.content,
  (newVal) => {
    editor.value?.setHTML(newVal);
  },
  {
    immediate: true,
  }
);
</script>

<template>
  <div>
    <QuillEditor
      ref="editor"
      @textChange="textChange"
      theme="snow"
      toolbar="full"
    />
  </div>
</template>

<style lang="scss" scoped></style>
